var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('mu-row',[_c('mu-col',{attrs:{"span":"12"}},[_c('picture',[_c('source',{attrs:{"type":"image/webp","srcset":`/images/travel_services/${_vm.image}${_vm.lang}.webp`}}),_vm._v(" "),_c('img',{attrs:{"src":`/images/travel_services/${_vm.image}${_vm.lang}.jpg`,"alt":`${_vm.service}`,"width":"100%"}})])])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }